import { useMutation } from "@apollo/client";
import Button from "components/Button/Button";
import Modal from "components/Modal/Modal";
import { deleteUserMutation } from "pages/Users/mutations";
import { useState } from "react";
import { toast } from "react-toastify";
import { User } from "TypesAndInterfaces";
import { displayError } from "utils/displayNotification";

interface IProps {
    isDeleteUserModalOpened: boolean,
    userToDelete: User,
    setIsDeleteUserModalOpened: Function,
    fetchUsers: Function
}

const DeleteUserForm = ({ isDeleteUserModalOpened, setIsDeleteUserModalOpened, fetchUsers, userToDelete } : IProps) => {

  //#region hooks
  const [buttonDisabled, setButtonDisabled] = useState(false);
  //#endregion

    //#region API CALLS
    const [deleteUser] = useMutation(deleteUserMutation, {
        onCompleted: () => {
          toast.info(`User deleted.`, {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setButtonDisabled(false);
        },
        onError: (e) => {
          displayError(e.message);
          setTimeout(() => {
            setButtonDisabled(false);
          }, 1500);
        }
      });
    //#endregion

    const handleIsDeleteUserModalOpened = (isOpened: boolean) => {
        setIsDeleteUserModalOpened(isOpened);
      };

    const handleDeleteUser = async () => {
      setButtonDisabled(true);
      await deleteUser({ variables: { userId: userToDelete.id } });
      fetchUsers();
    };

    return (
        <Modal
        isOpened={isDeleteUserModalOpened}
        className="delete-user"
        title="Delete User"
        setIsOpenedCallback={handleIsDeleteUserModalOpened}
      >
        <p>
          <strong>Are you sure you want to delete this user?</strong>
        </p>
        <div className="modal-buttons-container">
          <Button
            className="button--bordered button--error"
            type="button"
            content="No, keep it"
            onClick={() => setIsDeleteUserModalOpened(false)}
          ></Button>
          <Button
            className="button--error"
            type="button"
            content="Yes, delete it"
            disabled={buttonDisabled}
            onClick={() => { 
            try {
              handleDeleteUser();
            } catch (e) {
              toast.error("You cannot delete your own account!")
            }              
            setIsDeleteUserModalOpened(false);
            }}
          ></Button>
        </div>
      </Modal>
    );
};

export default DeleteUserForm;